import { useSelector } from 'react-redux';
import { Buttons, FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { phoneSelector } from 'Store/modules/auth/selectors';
import useTranslation from 'Hooks/useTranslation';
import { useFlags } from 'Hooks/useFlags';
import CustomTransition from 'Components/CustomTransition';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { routes } from 'Constants/routes';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { ABPhoneFlagsValue, FlagsKey } from 'Types/common';
import * as Styled from './styles';

const DgOnBoarding = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const info = useSelector(routeStateSelector);
  const { enabled, value } = useFlags(FlagsKey.PHONE_REQUEST_FLOW);
  const phoneSaved = useSelector(phoneSelector);

  const handleRedirect = (): void => {
    if (enabled && value === ABPhoneFlagsValue.INFO && !phoneSaved) {
      history.push(routes.DATAGATHERING_REQUEST_PHONE, {
        products: info?.products,
        value,
      });
    } else {
      history.push(routes.DATAGATHERING_FIRST_STEP, { products: info?.products });
    }
  };
  return (
    <OneColLayout>
      <FlexContainer direction="column" fullHeight justify="space-between">
        <Styled.OnBoardingContent>
          <CustomTransition start>
            <FlexContainer direction="column" align="center" justify="center" gap="dimension_24">
              <FlexContainer>
                <img
                  src={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/lock.svg`}
                  alt="AuthOnboarding"
                />
              </FlexContainer>
              <Text type="headline" color="dark" size="XS_M_M" align="center">
                {t('DG.Onboarding.title')}
              </Text>
              <Styled.OnBoardingText direction="column" align="center" gap="dimension_24">
                {[...Array(3).keys()].map(index => (
                  <Styled.ListItem key={index} align="center" gap="dimension_08">
                    <Icon icon="IconTickSolidSDark" color="cold" />
                    <Text type="paragraphs" size="S_M_S" color="dark">
                      {t(`DG.Onboarding.description.${index}`)}
                    </Text>
                  </Styled.ListItem>
                ))}
              </Styled.OnBoardingText>
            </FlexContainer>
          </CustomTransition>
        </Styled.OnBoardingContent>
        <Styled.ButtonContainer align="center" justify="center">
          <Buttons.Classic
            mode="primary"
            label={t('DG.Onboarding.button')}
            size="m"
            onClick={handleRedirect}
          />
        </Styled.ButtonContainer>
      </FlexContainer>
    </OneColLayout>
  );
};

export default DgOnBoarding;
